// Planned IO/CTS units, not delivered metrics or GT impression goals.
const nameKey = (value) => String(value || '').toLowerCase().replace(/\s+/g, ' ')
  .replace(/\s*([,_])\s*/g, '$1').trim();
const packageKey = (value) => value == null || String(value).trim() === '' ? '' : String(value).trim();

function count(value) {
  if (value == null || typeof value === 'boolean' || String(value).trim() === '') return null;
  const parsed = Number(String(value).replace(/,/g, '').trim());
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
}

export function gtUsesClicks(ag, pkg, campaign) {
  return String(ag.bid_type || pkg?.bid_type || campaign?.buying_model_raw || '')
    .trim().toUpperCase().startsWith('CPC');
}

/** Match line-item package rows, never repeat a parent package total on siblings. */
export function gtPlannedUnitSources(config) {
  const adgroups = config?.adgroups || [];
  const packages = config?.campaign?.cts_packages || [];
  const used = new Set();
  const siblings = new Map();
  for (const ag of adgroups) {
    const key = packageKey(ag.package_number);
    siblings.set(key, (siblings.get(key) || 0) + 1);
  }
  return adgroups.map((ag) => {
    const name = nameKey(ag.ad_group_name || ag.name);
    const number = packageKey(ag.package_number);
    const matches = packages.map((pkg, index) => ({ pkg, index })).filter(({ pkg, index }) => (
      !used.has(index) && name && name === nameKey(pkg.naming_conventions || pkg.ad_group_name || pkg.name)
      && (!number || !packageKey(pkg.package_number) || number === packageKey(pkg.package_number))
    ));
    // Identically named rows have no stable identity: do not guess between
    // different counts. Unique names remain safe even after rows are reordered.
    let match = matches.length === 1 ? matches[0] : null;
    if (!match && !matches.length && number && siblings.get(number) === 1) {
      const candidates = packages.map((pkg, index) => ({ pkg, index }))
        .filter(({ pkg, index }) => !used.has(index) && packageKey(pkg.package_number) === number);
      if (candidates.length === 1) match = candidates[0];
    }
    if (match) used.add(match.index);
    const pkg = match?.pkg;
    const isClicks = gtUsesClicks(ag, pkg, config?.campaign);
    const direct = count(isClicks ? ag.clicks : ag.impressions);
    // A mixed-model PDF IO cannot relabel CPM/AV impression inventory as
    // clicks merely because another package makes the whole campaign CPC.
    if (isClicks && config?._io_buying_model?.source === 'pdf'
        && ag._io_rate_terms?.rate_type !== 'CPC') return { pkg, value: direct };
    // CTS calls its combined Impressions/Clicks column `impressions`, including CPC buys.
    const packageCount = isClicks ? count(pkg?.clicks) ?? count(pkg?.impressions) : count(pkg?.impressions);
    return { pkg, value: direct ?? packageCount };
  });
}

export function gtPlannedUnits(config) {
  return gtPlannedUnitSources(config).map(source => source.value);
}
